module.exports = __webpack_public_path__ + "img/4-onebg.29f53f7d.png";